import { BaseDto } from './base.dto';
import { CostCentreDto } from './costCentre.dto';
import { MerchantDto } from './merchant.dto';
import { RecipeWastageDetailDto } from './recipeWastageDetail.dto';
import { StockWastageDetailDto } from './stockWastageDetail.dto';

export class StockWastageDto extends BaseDto {
    weekNo?: number;
    monthNo?: number;
    year?: number;
    stockCategoryId: number;
    wastageDay?: string;
    closed?: boolean;
    isProduct?: boolean;
    merchant: MerchantDto;
    costCentreId?: number;
    costCentre?: CostCentreDto;
    stockWastageDetails?: StockWastageDetailDto[];
    recipeWastageDetails?: RecipeWastageDetailDto[];
}
